import { payload } from "../../../../../node_modules/.pnpm/@sveltejs+kit@3.0.0-next.25_@sveltejs+vite-plugin-svelte@7.3.0_@voidzero-dev+vite-plus-_6af71ce724d780c153cb12f7c2a35374/node_modules/@sveltejs/kit/src/runtime/client/payload.js";
const env = payload.env;

export const PUBLIC_GOOGLE_ANALYTICS_MEASUREMENT_ID = "G-39QMLZEGS0";
export const PUBLIC_FINGERPRINT_API_KEY = "GW02jCdt7998QvCGh6D5";
